module.exports = __webpack_public_path__ + "static/media/aglow-logo.cccc8d35.png";